import { render, staticRenderFns } from "./LookingBack.vue?vue&type=template&id=24832344&scoped=true&lang=pug&"
import script from "./LookingBack.vue?vue&type=script&lang=ts&"
export * from "./LookingBack.vue?vue&type=script&lang=ts&"
import style0 from "./LookingBack.vue?vue&type=style&index=0&id=24832344&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24832344",
  null
  
)

export default component.exports